@import "../variables";

.main {
  max-width: 500px;
  margin: 15vh auto;
  padding: 0 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .title {
    color: $primaryOnBackground;
    font-size: calc(1.3rem + 0.6vw);
    font-weight: 600;
  }

  p {
    margin: 0;
  }

  .form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    width: 100%;
    text-align: left;

    label {
      font-weight: 600;
      font-size: 14px;
    }

    input {
      border: 1px solid #ccc;
      background-color: #fff;
      height: 41px;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;

      &:focus {
        outline: none;
        border-color: $primary;
      }
    }

    button {
      align-self: center;
      margin-top: 8px;
      width: 50%;
    }
  }
}
